import { useQuery } from "@tanstack/react-query";

import { getRanaApiV1 } from "@nens/rana/api-v1";

// Single

const getDatasetWmsLinkQuery = (datasetId: string | undefined) => {
  return getRanaApiV1().getQueryOptions({
    queryKey: ["dataset", "wms-link", datasetId],
    queryFn: async () => {
      if (!datasetId) throw Error("never happens");

      return getRanaApiV1().DatasetsApi.datasetWmsLinks({
        datasetId,
      });
    },
    enabled: !!datasetId,
  });
};

export const useDatasetWmsLinkQuery = (datasetId: string | undefined) => {
  return useQuery(getDatasetWmsLinkQuery(datasetId));
};
